<template>
	<section>
		<div class='knd-map' ref='map'>
			<div class='knd-map-ol' id='map' style=""></div>
			<div class='knd-tooltip' ref='tooltip'>
				<div v-if="tooltipInfo">
					
					<div v-if="tooltipInfo.Adres">
						<div>Aan de {{tooltipInfo.Adres.trim()}} in {{tooltipInfo.Plaats}} verrijst een nieuw distributiecentrum, met een oppervlakte van {{tooltipInfo['Grootte']}}{{tooltipInfo['Grootte_label']}}. De verwachte opleverdatum is {{tooltipInfo.Opleverdatum}}. 
						<span v-if="tooltipInfo['Greenfield'] === 'ja'">
							Voor deze locatie moet groen wijken.
						</span>
						</div>
					</div>

					<div v-if="tooltipInfo['Status'] === 'Ontwerp' || tooltipInfo['Status'] === 'Voorontwerp'">
						Hier wil de gemeente het bedrijventerrein {{tooltipInfo.Bedrijventerrein}} ontwikkelen met ruimte voor een {{tooltipInfo['Grootte']}}-distributiecentrum.
						<span v-if="tooltipInfo['Greenfield'] === 'ja'">
							Voor deze locatie moet groen wijken.
						</span>
						<span v-if="tooltipInfo['Link bestemmingsplan']">De plannen zijn in ontwerp en <a :href="tooltipInfo['Link bestemmingsplan']" target="_blank">hier</a> te vinden.</span>

					</div>


					<div v-if="tooltipInfo['Status'] === 'Vastgesteld'">
						Het bedrijventerrein {{tooltipInfo.Bedrijventerrein}} biedt ruimte voor een {{tooltipInfo['Grootte']}}-distributiecentrum.
						<span v-if="tooltipInfo['Greenfield'] === 'ja'">
							Voor deze locatie moet groen wijken.
						</span>
						<span v-if="tooltipInfo['Link bestemmingsplan']">De plannen zijn goedgekeurd en <a :href="tooltipInfo['Link bestemmingsplan']" target="_blank">hier</a> te vinden.</span>
					</div>

				</div>
			</div>

			<div class='knd-legenda' v-if='showLegend'>
				<div class='inner-legenda'>
						<h5 class='knd-legenda__title'>Legenda</h5>

						<ul class='knd-legenda__list'>
							<li>
									<div class='legenda-icon'>
										<img src='@/assets/icon_cobouw.svg' />
									</div>
									<div class='legende-label'>geplande distributiecentra</div>
							</li>

							<li>
									<div class='legenda-icon'>
										<img src='@/assets/icon_investico.svg' />
									</div>
									<div class='legende-label'>ruimte voor distributiecentra</div>
							</li>
							<li>
									<div class='legenda-icon'>
										<img src='@/assets/icon_fill_highlight_green_circle.png' />
									</div>
									<div class='legende-label'>groene locatie</div>
							</li>

						</ul>
				</div>
			</div>

			<div class='knd-tool'  v-show='showTool'>
				<div class='knd-nav'>
					<div class='knd-nav_inner'>
						<div class='knd-autocomplete' >
							<span class='tool-label'>zoek op</span>
								<input ref='awesomplete' type="number" placeholder='postcode' />
						</div>

						<div class='knd-tool__radius'>
							<span class='tool-label'>straal</span>
							<select v-model="radiusMeter" @change="onChangeSelect()">
								<option selected>5</option>
								<option>10</option>
								<option>15</option>
							</select>
							<span class='tool-label-metric'>km</span>
						</div>
				</div>

					<div class='current_locations m-t-sm'>
						<input type="checkbox" id="currentToggle" name="current_toggle" v-model="showLocations"/>
						<label for="currentToggle" class="current_toggle">
							bestaande distributiecentra
					</label>
				</div>

				</div>
				<div class='knd-info' v-show="currentLocation">
					<div v-if="totalItemsGepland">
						Er {{totalItemsGepland === 1 ? 'staat' : 'staan'}} <span class='knd-bold'>{{totalItemsGepland}} nieuwe grote {{totalItemsGepland === 1 ? 'distributiecentrum' : 'distributiecentra'}}</span> in de planning<span v-if="totalItemsRuimte > 0"> en er is nog ruimte beschikbaar voor {{totalItemsRuimte}}  {{totalItemsRuimte === 1 ? 'groot pakhuis' : 'grote pakhuizen'}}</span>.
						<span v-if="greenFieldItems > 0"> Hiervan is {{greenFieldItems.length}} is in een groene omgeving.</span> Klik op de iconen in de kaart voor meer informatie.
					</div>
					<div v-else-if="currentLocation"> 
						Er staan geen distributiecentra in de planning in deze omgeving.
					</div>
				</div>
				
			</div>

		</div>
			<div class='knd-source'>
					Bron: Bestaande distributiecentra <a href='https://mertennefs.eu/landscapes-of-trade/' target='_blank'>Landscape of trade, Merten Nefs</a>; Geplande distributiecentra Cobouw; Investico

			</div>
	</section>
</template>

<script>

	// https://gis.stackexchange.com/questions/346459/openlayers-5-foreachfeatureintersectingextent-method-not-correctly-selecting-fea

	import Map from 'ol/Map';
	import View from 'ol/View';
	import XYZ from 'ol/source/XYZ';
	import {transformExtent, fromLonLat, getPointResolution} from 'ol/proj';
	import {Circle} from 'ol/geom';
	import Feature from 'ol/Feature';
	import {Circle as CircleStyle, Fill, Stroke, Style, Icon, RegularShape} from 'ol/style';
	import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
	import VectorSource from 'ol/source/Vector';
	import TopoJSON from 'ol/format/TopoJSON';
	import {Control, defaults as defaultControls} from 'ol/control';
	import { Select} from 'ol/interaction';
	import {never} from 'ol/events/condition';
	import GeoJSON from 'ol/format/GeoJSON';
	import LinearRing from "ol/geom/LinearRing";
	import Valid from 'jsts/org/locationtech/jts/operation/valid/IsValidOp';

	import {getCurrentStyle, getRadiusStyle, getZipStyle, getMarkerStyle} from './styles';

	import {DragPan, MouseWheelZoom, defaults} from 'ol/interaction';
	import {platformModifierKeyOnly} from 'ol/events/condition';
	import {
		LineString,
		MultiLineString,
		MultiPoint,
		MultiPolygon,
		Point,
		Polygon,
	} from 'ol/geom';

	import 'ol/ol.css';

	import DistributieCentraJson from '@/assets/estates2021NL_repo.json';

	import * as jsts from 'jsts/dist/jsts.min.js';

	import * as Awesomplete from 'awesomplete';
	import 'awesomplete/awesomplete.css';

	import './kaart.scss';

	export default {
		name: 'Articles',
		mounted: function() {
			this.draw();
			this.renderAutoComplete();

			// this is for the iframe, pass the height
			if (window.parent && window.parent.postMessage) {
				this.$nextTick( () => {

					// let el = this.$refs.map;
					let maxHeight = Math.min(window.outerHeight - 50, 700);

					let message = { 
						source: 'knd', 
						'knd-height': maxHeight, 
						'knd-width': window.outerWidth 
					};	
					window.top.postMessage(message, "*");
				});
			}
		},

		computed: {
			step() {
				return this.$store.getters.step;
			}
		},

		watch: {
			step(newValue, oldValue) {
				if(newValue && newValue !== oldValue) {
					this.renderStep(newValue);
				}
			},

			showLocations(newValue) {
				let hasCurrent = this.hasLayer('current');

				if(newValue === true && !hasCurrent){
					this.map.getLayers().insertAt(1, this.currentLocations);
				}	else if (hasCurrent) {
					this.map.removeLayer(this.currentLocations);
				}
			}
		},
		data: function() {
			return {
				tooltipInfo: undefined,
				selection: undefined,
				radiusMeter: 5,
				totalItemsGepland: undefined,
				totalItemsRuimte: undefined,
				currentLocation: undefined,
				greenFieldItems: undefined,
				showTool: false,
				showLocations: false,
				showLegend: false
			}
		},
		methods: {

			renderStep(step) {
				let hasCobouw = this.hasLayer('cobouw');
				let hasInvestico = this.hasLayer('investico');
				let hasCurrent = this.hasLayer('current');

				switch(step.key) {
					case 'huidig':
						if(!hasCurrent) {
							this.map.getLayers().insertAt(1, this.currentLocations);
						}

						if(hasCobouw) {
							this.map.removeLayer(this.cobouwLocations);
						}
						break;
					case 'cobouw':
						if(hasCurrent) {
							this.map.removeLayer(this.currentLocations);
						}
						
						if(!hasCobouw) {
							this.map.addLayer(this.cobouwLocations);
						}

						if(hasInvestico) {
							this.map.removeLayer(this.newLocations);
						}
						break;
					case 'investico':
						if(!hasInvestico) {
							this.map.getLayers().insertAt(1, this.newLocations);
							this.showHideFeatures(this.cobouwLocations, this.cobouwLocationsStyle, true);
							this.showHideFeatures(this.newLocations, this.newLocationsStyle, true);

						}
						break;
					case 'groen':
						this.showHideFeatures(this.cobouwLocations, this.cobouwLocationsStyle);
						this.showHideFeatures(this.newLocations, this.newLocationsStyle);
						this.showTool = false;
						break;
					case 'postcode':
							if(!hasCobouw) {
								this.map.addLayer(this.cobouwLocations);
							}
							if(!hasInvestico) {
								this.map.getLayers().insertAt(1, this.newLocations);
							}

							this.showHideFeatures(this.cobouwLocations, this.cobouwLocationsStyle, true);
							this.showHideFeatures(this.newLocations, this.newLocationsStyle, true);
							this.showTool = true;
						break;
					case 'showall':
							this.map.addLayer(this.newLocations);
							this.map.addLayer(this.cobouwLocations);
							this.showTool = true;
							this.showLegend = true;
						break;

				}
			},

			showHideFeatures(layer, style, showAll) {
				var layer_select_geometries = layer
					.getSource()
					.getFeatures()
					.forEach((el) => {						
						if(el.getProperties()['Greenfield'] === 'nee' && !showAll) {
							el.setStyle(new Style(null));
						} else {
							el.setStyle(style);
						}
					});
			},

			hasLayer(name) {
				let arr = this.map.getLayers().getArray();
				let search = arr.find(layer => layer.get('name') === name);
				return search;
			},

			onChangeSelect() {
				if(this.currentLocation) {
					this.buildFeature(this.currentLocation.x, this.currentLocation.y)
				}
			},
			// https://stackoverflow.com/questions/60949650/cannot-get-circle-radius-correct-in-openlayers
			buildFeature(x, y) {
				var centerLongitudeLatitude = fromLonLat([x, y]);
				var viewProjection = this.map.getView().getProjection();
				var pointResolution = getPointResolution(viewProjection , 1, centerLongitudeLatitude );
				var radius = (this.radiusMeter * 1000) / pointResolution;

				this.currentLocation = {
					x: x, y:y
				}

				this.map.removeLayer(this.zipLayer);
				this.map.removeLayer(this.zipRadiusLayer);

				console.log(x,y)
				// https://appelsiini.net/circles/?c=52.35669,4.91334,5000

				this.zipLayer = new VectorLayer({
					source: new VectorSource({
						projection: 'EPSG:4326',
						features: [new Feature(new Circle(centerLongitudeLatitude, 3))]
					}),
					style: [
						getZipStyle()
					]
				});

				let radiusCircle = new Feature(new Circle(centerLongitudeLatitude, radius));

				this.zipRadiusLayer = new VectorLayer({
					source: new VectorSource({
						projection: 'EPSG:4326',
						features: [radiusCircle]
					}),
					style: [
						getRadiusStyle()
					]
				});


				this.map.addLayer(this.zipLayer);
				this.map.addLayer(this.zipRadiusLayer);

				this.select.getFeatures().clear();
				const valid = new Valid();

				const extent = radiusCircle.getGeometry().getExtent();

				var parser = new jsts.io.OL3Parser();
				parser.inject(
					Point,
					LineString,
					LinearRing,
					Polygon,
					MultiPoint,
					MultiLineString,
					MultiPolygon
				);

				var reader_wkt = new jsts.io.WKTReader();

				var geom_select = radiusCircle.getGeometry();
				var pt = reader_wkt.read('POINT (' + geom_select.getCenter().join(' ') + ')')
				var jsts_geom_select = pt.buffer(geom_select.getRadius());

				var layer_select_geometries = this.newLocations
					.getSource()
					.getFeatures()
					.filter((el) => {						
						let contains = parser.read(el.getGeometry());
						if (jsts_geom_select.contains(contains)) {
							return true;
						}
					});

				var layer_select_geometries_2 = this.cobouwLocations
					.getSource()
					.getFeatures()
					.filter((el) => {						
						let contains = parser.read(el.getGeometry());
						if (jsts_geom_select.contains(contains)) {
							return true;
						}
					});				

				this.select.getFeatures().extend(layer_select_geometries);
				this.select.getFeatures().extend(layer_select_geometries_2);

				let arr = this.select.getFeatures().getArray();
				this.selection = arr;
				this.totalItemsGepland = this.selection.filter(d => {
					return d.getProperties()['Adres'];
				}).length;

				this.totalItemsRuimte = this.selection.filter(d => {
					return d.getProperties()['Bedrijventerrein'];
				}).length;

				this.greenFieldItems = this.selection.filter(d => {
					return d.getProperties()['Greenfield'] === 'ja';
				})

				this.map.getView().fit(extent, { duration: 1000, padding: [100, 30, 0, 30] });

			},

			getCurrentLocations() {
				let style = getCurrentStyle();

				let vectorSource = new VectorSource({
					features: new TopoJSON({layers: ['estates2021NL_repo']}).readFeatures(DistributieCentraJson, {
							dataProjection: 'EPSG:4326',
							featureProjection: 'EPSG:3857'
					}),
					overlaps: false,
				})

				let vector = new VectorLayer({
					source: vectorSource,
					style: style,
					properties: {
						name: 'current'
					}
				});

				return vector;

			},

			getNewLocations(data, image, name) {
				const features = [];
				this.source = new VectorSource();

				data.forEach(d => {
					const coords = fromLonLat([+d.lng, +d.lat], 'EPSG:3857');

					features.push(
						new Feature({
							...d,
							geometry: new Point(coords),
						})
					);
				})

				this.source.addFeatures(features);

				const newLocations = new VectorLayer({
					properties: {
						name: name
					},
					source: this.source,
					style: function(feature, resolution){
						return getMarkerStyle(feature, image);
					},			
				className: 'knd-new'
				});

				return newLocations;
			},

			getSelect(image) {
				let select = new Select({
					layers: [],
					condition: never,
					style: function(feature, resolution){
						let src = feature.get('Greenfield') == 'nee' ? `${image}.svg` : `${image}_green_circle.svg` ;
							var style = new Style({
								image: new Icon({
									opacity: .8,
									anchor: [0.5, 0.96],
									src: require(`@/assets/${src}`),
									scale: .8
								})
							});

							return style;
					},								
				});

				return select;
			},

			showAll() {
				this.map.addLayer(this.newLocations);
				this.map.addLayer(this.cobouwLocations);
			},

			draw() {
				this.currentLocations = this.getCurrentLocations();
				this.cobouwLocations = this.getNewLocations(this.$store.getters.cobouw, 'icon_cobouw', 'cobouw');
				this.newLocations = this.getNewLocations(this.$store.getters.verdozing, 'icon_investico', 'investico');

				this.cobouwLocationsStyle = this.cobouwLocations.getStyle();
				this.newLocationsStyle = this.newLocations.getStyle();

				var Esri_WorldGrayCanvas = new TileLayer({
					source: new XYZ({
						url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
							attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
					}),
					maxZoom: 16
				});

				var nlmaps_grijs = new TileLayer({
					source: new XYZ({
						url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/water/EPSG:3857/{z}/{x}/{y}.png',
							attributions: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>',
					}),
					minZoom: 6,
					maxZoom: 19,
					bounds: [[50.5, 3.25], [54, 7.6]]
				});


				this.zipLayer;
				this.zipRadiusLayer;

				this.view = new View({
					zoom: 11,
					minZoom: 7,
					maxZoom: 15,
					padding: [80, 10, 10, 10]
				})

				let dragging = true;

				if (this.mobileAndTabletCheck()) {
					dragging = false;
				}				

				this.map = new Map({
					controls: defaultControls(),
					interactions: defaults({dragPan: dragging, mouseWheelZoom: false}).extend([
						new DragPan({
							condition: function (event) {
								return this.getPointerCount() === 2 || platformModifierKeyOnly(event);
							},
						}),
						new MouseWheelZoom({
							condition: platformModifierKeyOnly,
						}),
					]),					
					target: 'map',
					layers: [
						nlmaps_grijs,
						// this.currentLocations
					],
					view: this.view
				});

				this.map.on('click', (e) => this.displayFeatureInfo(e));

				var extent = transformExtent(
					[3.3585237662812415,50.75119188403309,7.228097629289882,53.556553549681915],
					"EPSG:4326", "EPSG:3857"
				);


				this.map.getView().fit( extent, this.map.getSize() );
				var CenterOfGeom = this.map.getView().getCenter();

				this.select = this.getSelect('icon_fill_highlight');
				this.map.addInteraction(this.select);				
			},

			mobileAndTabletCheck() {
				let check = false;
				(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
					return check;
			},

			numberWithCommas(x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
			},

			displayFeatureInfo (e) {
				let tooltip = this.$refs.tooltip;
				let pixel = e.pixel;

				const feature = this.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
					if(layer.getClassName() !== 'knd-new') return;
					return feature;
				});

				if (!feature) {
					tooltip.classList.remove('show');
					return;
				} 

				tooltip.classList.add('show');
				this.tooltipInfo = feature.getProperties();

				if(this.tooltipInfo['Grootte']) {
					let m2 = +this.tooltipInfo['Grootte'];
					this.tooltipInfo['Grootte'] = this.numberWithCommas(this.tooltipInfo['Grootte']);
					this.tooltipInfo['Grootte_label'] = '';
					if(!isNaN(m2)) {
						this.tooltipInfo['Grootte_label'] += ' m2';
						if(m2 >= 25000 && m2 < 40000) {
							this.tooltipInfo['Grootte_label'] += ' (XL)';
						} else if (m2 >= 40000) {
							this.tooltipInfo['Grootte_label'] += ' (XXL)';
						}
					}
				}

				// debugger;

				let padding = 15;
				let tooltipWidth = tooltip ? tooltip.offsetWidth : 0;
				let tooltipHeight = tooltip ? tooltip.offsetHeight : 0;

				let xPos = pixel[0];
				let yPos = pixel[1];

				let top = window.innerHeight > yPos + tooltipHeight + padding
					? yPos + padding
					: yPos - tooltipHeight - padding;


				let tooltipYpos = top;
				let tooltipXpos = xPos - (tooltipWidth /2);
				tooltip.style.left = tooltipXpos + 'px';
				tooltip.style.top = tooltipYpos + 'px';
			},

			renderAutoComplete(){				
				let data = this.$store.getters.zipcodes.map(d => {
					return {label: d.PC4, value: [d.x, d.y]}
				});

				this.input = this.$refs.awesomplete;

				new Awesomplete(this.input, {
					list: data,
					filter: function (text, input) {
						return text.indexOf(input) === 0;
					},
					replace: (suggestion) => {
						this.input.value = suggestion.label;

						let arr = suggestion.value;
						this.buildFeature(+arr[0], +arr[1]);

						// this.$store.dispatch('onSearch', suggestion.value);

					}
				});

			}
		}
	}
</script>